<template>
  <div class="wrap">
    <div class="card">
      <div class="brand">
        <img class="brandLogo" :src="ravenLogo" alt="Raven" />
        <div class="h">Raven GTM</div>
      </div>

      <div class="status-icon">🔒</div>
      <div class="status-text">Access Not Enabled</div>
      <div class="sub-text">Your account hasn't been granted access to Raven. Please contact your administrator.</div>
      <a class="btn primary" :href="MAIN_PRODUCT_URL">Go to LeadIQ</a>
    </div>
  </div>
</template>

<script setup>
import ravenLogo from '../assets/raven.svg'
import { MAIN_PRODUCT_URL } from '../env'
</script>

<style scoped>
.wrap {
  height: 100vh;
  display: grid;
  place-items: center;
  background: #f9fafb;
}

.card {
  width: min(420px, 92vw);
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.brandLogo {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.h {
  font-weight: 700;
  font-size: 18px;
}

.status-icon {
  font-size: 48px;
  margin: 16px 0;
}

.status-text {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
}

.sub-text {
  font-size: 13px;
  color: var(--muted);
  margin-top: -8px;
}

.btn {
  margin-top: 8px;
  width: 100%;
  text-decoration: none;
}
</style>
